import { render } from "./tokenEconomyScreen.vue?vue&type=template&id=77eedf12"
import script from "./tokenEconomyScreen.vue?vue&type=script&lang=js"
export * from "./tokenEconomyScreen.vue?vue&type=script&lang=js"

import "./tokenEconomyScreen.vue?vue&type=style&index=0&id=77eedf12&lang=scss"

import exportComponent from "F:\\freelance\\web development\\project twelve\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__